export type { CertificateStatusCardProps } from './certificate-status-card';
export { CertificateStatusCard } from './certificate-status-card';
